'use client';
import React from 'react';
import styles from './back.module.css';
import { useRouter } from 'next/navigation';

export default function Back({
	direction = 'left',
	content = 'Go Back',
	to,
	cls,
}: {
	direction?: 'left' | 'center' | 'right';
	content?: React.ReactNode;
	to?: string;
	cls?: string;
}) {
	const router = useRouter();

	const handleGoBack = () => {
		if (to) {
			router.replace(to);
		} else {
			router.back();
		}
	};

	return (
		<button
			className={cls ? cls : styles.btn}
			style={{
				marginLeft: direction === 'left' ? 'auto' : '',
			}}
			onClick={handleGoBack}
		>
			{content}
		</button>
	);
}
